import React from "react";
import { ChartSpec } from "./types";
import ChartCanvas from "./ChartCanvas";

interface Props {
  spec: ChartSpec;
}

const ChartCard: React.FC<Props> = ({ spec }) => {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 12,
        marginTop: 8,
      }}
    >
      {spec.title || spec.subtitle ? (
        <div style={{ marginBottom: 6 }}>
          {spec.title ? (
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{spec.title}</div>
          ) : null}
          {spec.subtitle ? (
            <div style={{ fontSize: 11, color: "#6b7280" }}>{spec.subtitle}</div>
          ) : null}
        </div>
      ) : null}
      <ChartCanvas spec={spec} />
    </div>
  );
};

export default ChartCard;
